import * as e from "react";
import a from "../lib/IconBase.es.js";
import p from "../defs/SpinnerGap.es.js";
const o = e.forwardRef((r, n) => /* @__PURE__ */ e.createElement(a, { ref: n, ...r, weights: p }));
o.displayName = "SpinnerGapIcon";
const m = o;
export {
  m as SpinnerGap,
  o as SpinnerGapIcon
};
